import { getGlobalDateTimeFilter } from "services";

export const categoryReportFilterState = (venueId) => {
  const dateTime = getGlobalDateTimeFilter();
  return {
    venueId,
    page: 1,
    pageSize: 20,
    searchKey: "",
    dateRange: [dateTime[0], dateTime[1]],
    locations: [],
    staffs: [],
    category: null,
    sort: { key: "sale", value: "desc" },
  };
};
